<template>
  <div class="input-group">
    <label for="proveedores">Proveedores</label>
    <select id="proveedores" v-model="proveedor" @change="change">
      <option value="">Seleccione...</option>
      <option v-for="item in proveedores" :key="item.id" :value="item">
        {{item.nombre | upper}}
      </option>
    </select>
    <i class="bar"></i>
  </div>
</template>

<script>
  export default {
    name: "Proveedor",
    created() {
      this.$store.dispatch('loadProveedores')
    },
    methods: {
      change() {
        this.$emit('changeProvider', this.proveedor)
      }
    },
    computed: {
      proveedores() {
        return this.$store.getters.proveedores
      },
      proveedor: {
        get() {
          return this.$store.state.sugeridoCompra.filtros.proveedor
        },
        set(value) {
          this.$store.commit("sugeridoCompra/SET_FILTRO", {key: "proveedor", data: value})
          this.$store.dispatch("sugeridoCompra/getProductosSugerido")
          this.$store.dispatch("sugeridoCompra/resetPages")

        }
      }
    }
  }
</script>

<style scoped>
  label {
    font-weight: bold;
  }

  select {
    height: 2em;
    cursor: pointer;
  }

  option {
    cursor: pointer;
  }
</style>
